import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../stores/store';
import {
  fetchKozelTUserScores,
  addKozelTScore,
  generateKozelTUserId,
  clearKozelTUuid,
  fetchKozelTBestScores,
} from '../../features/games/kozelBattleTSlice';
import BattleGamePopupT from './BattleGamePopupT';

const GameT: React.FC = () => {
  const dispatch = useAppDispatch();
  const { uuid, bestLightScore, bestDarkScore } = useAppSelector(
    (state) => state.kozelBattleT
  );
  const [showPopup, setShowPopup] = useState(false);
  const [gameOverScore, setGameOverScore] = useState(0);

  useEffect(() => {
    dispatch(fetchKozelTBestScores());
    const userId = uuid || localStorage.getItem('kozelBattleTUuid');
    if (userId) {
      dispatch(fetchKozelTUserScores(userId));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'KOZEL_GAME_OVER') {
        const { score, chosenMole } = event.data;
        const userId = uuid || localStorage.getItem('kozelBattleTUuid');

        if (userId && typeof score === 'number' && score > 0) {
          const team: 'light' | 'dark' = chosenMole === 0 ? 'light' : 'dark';
          dispatch(addKozelTScore({ unique_id: userId, team, score }));
        }

        setGameOverScore(typeof score === 'number' ? score : 0);
        setShowPopup(true);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [uuid, dispatch]);

  const handlePlayAgain = async () => {
    setShowPopup(false);
    dispatch(clearKozelTUuid());
    localStorage.removeItem('kozelBattleTUuid');
    try {
      await dispatch(generateKozelTUserId()).unwrap();
    } catch {
      // ignore
    }
    // Reîncarcă iframe-ul reîncărcând componenta
    window.location.reload();
  };

  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 9999,
      backgroundColor: '#1a0a00',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Best scores header */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: { xs: '8px 16px', sm: '12px 32px' },
        backgroundColor: '#40301E',
        borderBottom: '2px solid #D1A85E',
        flexShrink: 0,
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ color: '#E3CB9F', fontSize: { xs: '0.7rem', sm: '0.85rem' }, fontWeight: 'bold', letterSpacing: 1 }}>
            #TEAMBLONDE
          </Typography>
          <Typography sx={{ color: '#E3CB9F', fontSize: { xs: '1.4rem', sm: '2rem' }, fontWeight: 'bold' }}>
            {bestLightScore}
          </Typography>
          <Typography sx={{ color: '#E3CB9F', fontSize: '0.7rem' }}>cel mai bun scor</Typography>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ color: '#E3CB9F', fontSize: { xs: '0.7rem', sm: '0.85rem' }, fontWeight: 'bold', textAlign: 'center', lineHeight: 1.4 }}>
            CEL MAI BUN SCOR
          </Typography>
          <Typography sx={{ color: '#D1A85E', fontSize: { xs: '0.65rem', sm: '0.75rem' }, textAlign: 'center', fontStyle: 'italic' }}>
            Poți bate recordul?
          </Typography>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ color: '#E3CB9F', fontSize: { xs: '0.7rem', sm: '0.85rem' }, fontWeight: 'bold', letterSpacing: 1 }}>
            #TEAMDARK
          </Typography>
          <Typography sx={{ color: '#E3CB9F', fontSize: { xs: '1.4rem', sm: '2rem' }, fontWeight: 'bold' }}>
            {bestDarkScore}
          </Typography>
          <Typography sx={{ color: '#E3CB9F', fontSize: '0.7rem' }}>cel mai bun scor</Typography>
        </Box>
      </Box>

      {/* Iframe joc */}
      <Box sx={{ flex: 1, overflow: 'hidden', minHeight: 0 }}>
        <iframe
          src="/whackamoleT/game/index.html"
          title="Kozel Battle Tablet"
          style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
          allow="autoplay"
        />
      </Box>

      {/* Popup final */}
      <BattleGamePopupT
        isOpen={showPopup}
        onClose={handlePlayAgain}
        score={gameOverScore}
      />
    </Box>
  );
};

export default GameT;